import { CssBaseline as MuiCssBaseline } from '@mui/material';
import type { CssBaselineProps as MuiCssBaselineProps } from '@mui/material/CssBaseline';

export type CssBaselineProps = MuiCssBaselineProps;

export const CssBaseline = ({ ...rest }: CssBaselineProps): JSX.Element => (
  <MuiCssBaseline {...rest} />
);
